<template>
  <div class="address-category-form-modal">
    <modal-frame :showModalFlag="modalDisplay" v-on:backdropClickEvent="cancel">
      <div class="modal-header">
        <h1>{{ titleString }}</h1>
      </div>
      <div class="modal-body">
        <attribute-in-form
          :labelText="'グループ名'"
          :necessary="true"
          :validationState="validateCategoryName.state"
          :validationMessage="validateCategoryName.message"
          :attributeNotify="''">
          <input type="text" size="25" v-model="categoryName" />
        </attribute-in-form>
        <div class="form-controll">
          <button class="cancel-btn" @click="cancel">キャンセル</button>
          <button class="submit-btn" :class="{ disable: !validateCategoryName.valid }" @click="submit">{{ submitText }}</button>
        </div>
      </div>
    </modal-frame>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'
import AttributeInForm from '@/components/common/AttributeInForm.vue'

export default {
  name: 'AddressCategoryFormModal',

  components: {
    ModalFrame,
    AttributeInForm,
  },

  props: {
    category: Object,
    modalDisplay: Boolean,
  },

  emits: [
    'cancelEvent',
    'createFinishedEvent',
    'createFailedEvent',
    'updateFinishedEvent',
    'updateFailedEvent',
  ],

  data () {
    return {
      categoryName: ''
    }
  },

  watch: {
    modalDisplay: { handler: 'initData', immediate: true },
  },

  computed: {
    ...mapState({
      addressBook: state => state.addressBook.addressCategories,
    }),

    titleString () {
      if (this.category) {
        return '連絡先グループ編集'
      } else {
        return '連絡先グループ追加'
      }
    },

    submitText () {
      if (this.category) {
        return '更新'
      } else {
        return '追加'
      }
    },

    validateCategoryName () {
      // check empty and doubled.
      const segmenter = new Intl.Segmenter("ja-JP", { granularity: "grapheme"})
      if (!this.categoryName || this.categoryName.trim().length <= 0) {
        return { valid: false, state: 'invalid', message: 'グループ名に空白を指定できません' }
      } else if ([...segmenter.segment(this.categoryName.trim())].length > 6) {
        return { valid: false, state: 'invalid', message: 'グループ名は6文字以下にする必要があります'}
      } else if (this.category) {
        if (this.addressBook.some((cate) => (cate.name === this.categoryName && cate.id !== this.category.id))) {
          return { valid: false, state: 'invalid', message: 'グループ名が重複しています' }
        }
      } else if (this.addressBook.some((cate) => cate.name === this.categoryName)) {
        return { valid: false, state: 'invalid', message: 'グループ名が重複しています' }
      }
      return { valid: true, state: 'valid', message: '' }
    }
  },

  methods: {
    ...mapActions({
      createCategory: 'addressBook/create',
      updateCategory: 'addressBook/update',
    }),

    initData () {
      if (this.category) {
        this.categoryName = this.category.name
      } else {
        this.categoryName = ''
      }
    },

    cancel () {
      this.$emit('cancelEvent')
    },

    submit () {
      if (this.validateCategoryName.valid) {
        let formData = new FormData()
        formData.append('name', this.categoryName)
        if (this.category) {
          console.log('gonna update')
          formData.append('id', this.category.id)
          this.updateCategory(formData).then(() => {
            this.$emit('updateFinishedEvent')
          }).catch(error =>{
            console.error(error)
            this.$emit('updateFailedEvent')
          })
        } else {
          console.log('gonna create')
          this.createCategory(formData).then(() => {
            this.$emit('createFinishedEvent')
          }).catch(error =>{
            console.error(error)
            this.$emit('createFailedEvent')
          })
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.address-category-form-modal {
  margin: 0;
  .modal-header {
    padding: 15px;
    padding-bottom: 0;
    h1 {
      margin: 0;
      font-size: 22pt;
      font-weight: normal;
    }
  }
  .modal-body {
    padding: 15px;
    input[type=text] {
      border-radius: 5px;
      height: 30px;
      font-size: 16pt;
    }
    .form-controll {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      button {
        padding: 3px 5px;
        min-width: 100px;
        border-radius: 5px;
        border: 1px solid #aaa;
      }
      .cancel-btn {
        background-color: #eee;
        color: $normal-btn-color;
        border-color: $normal-btn-color;
      }
      .submit-btn {
        background-color: $success-color;
        color: $normal-btn-text-color;
        border-color: $success-color;
        font-weight: bold;
        &.disable {
          background-color: $disable-btn-color;
          border-color: $disable-btn-color;
        }
      }
    }
  }
}
</style>